import React from 'react';
import { QuickSearchCommands } from '@atlassian/jira-command-palette-quick-search/src/ui/index.tsx';
import { InitialiseAdminNavCommands } from './admin-nav-commands/index.tsx';
import { ThemeModeCommands } from './theme-mode-commands/index.tsx';

/** Use to render conditional commands */
export const RegisterDynamicCommands = () => (
	<>
		<InitialiseAdminNavCommands />
		<QuickSearchCommands />
		<ThemeModeCommands />
	</>
);
